import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

import { ModalProvider, Modal } from "./context/Modal";
import configureStore from "./store";
import * as sessionActions from "./store/session";
import App from "./App";
import ErrorBoundary from './components/ErrorBoundary';
import "./index.css";
import './i18n';

const store = configureStore();

// Expose store and sessionActions globally in development for debugging
if (process.env.NODE_ENV !== "production") {
	window.store = store;
	window.sessionActions = sessionActions;
}

if (process.env.NODE_ENV === "production" && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then((registration) => {
                console.log('ServiceWorker registration successful:', registration);
            })
            .catch((error) => {
                console.error('ServiceWorker registration failed:', error);
            });
    });
}


function Root() {
	return (
		<Provider store={store}>
			<ModalProvider>
				<BrowserRouter>
					<ErrorBoundary>
						<App />
					</ErrorBoundary>
					<Modal />
				</BrowserRouter>
			</ModalProvider>
		</Provider>
	);
}

ReactDOM.render(
	<Root />,
	document.getElementById("root")
);
